<template>
  <div class="studio-testimonial-preview">
    <div class="studio-testimonial-preview-background"></div>
    <h1 class="mb-4 text-center">
      {{ data.title }}
    </h1>
    <swiper
      ref="swiper"
      class="swiper"
      :options="swiperOption"
      @slideChange="slideChange"
    >
      <swiper-slide
        v-for="testimonial in data.testimonials"
        :key="testimonial.id"
        class="text-center mx-4"
      >
        <div class="row justify-content-center">
          <div class="col-11 col-md-8">
            <h4>
              {{ testimonial.name }}
            </h4>
            <h5 class="mt-3 c-dark-gray">
              {{ testimonial.title }}
            </h5>
            <div
              class="testimonial mt-3"
              v-html="testimonial.testimonial"
            ></div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-nav swiper-nav--prev" slot="button-prev">
        <font-awesome-icon :icon="['far', 'angle-left']" />
      </div>
      <div class="swiper-nav swiper-nav--next" slot="button-next">
        <font-awesome-icon :icon="['far', 'angle-right']" />
      </div>
    </swiper>
    <div class="d-flex justify-content-center mt-4">
      <div
        v-for="(testimonial, $index) in data.testimonials"
        :key="testimonial.id"
        class="swiper-thumbnail embed-responsive embed-responsive-1by1"
        :class="{
          active: swiperActiveIndex === $index,
        }"
        :style="{
          backgroundImage: `url(${testimonial.photo_obj.thumbnail})`,
        }"
        @click="slideTo($index)"
      ></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

const INITIAL_SLIDE = 0;

export default Vue.extend({
  name: 'StudioTestimonialPreview',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      swiperActiveIndex: INITIAL_SLIDE,
      swiperOption: {
        initialSlide: INITIAL_SLIDE,
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 0,
          modifier: 1,
          slideShadows: false,
        },
        navigation: {
          nextEl: '.swiper-nav--next',
          prevEl: '.swiper-nav--prev',
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.swiper?.$swiper;
    },
  },
  methods: {
    slideTo(index) {
      this.swiper.slideTo(index, 1000, false);
    },
    slideChange() {
      this.swiperActiveIndex = this.swiper?.activeIndex;
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.studio-testimonial-preview {
  position: relative;
}

.studio-testimonial-preview-background {
  position: absolute;
  background-color: $lightest-gray;
  left: 50%;
  height: calc(100% + 6rem);
  width: 100vw;
  top: -3rem;
  transform: translate(-50%, 0%);
  z-index: -1;
}

.swiper-thumbnail {
  border-radius: 50%;
  width: 60px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.6;
  cursor: pointer;
  @include media-breakpoint-up(md) {
    width: 120px;
  }
  + .swiper-thumbnail {
    margin-left: 1rem;
    @include media-breakpoint-up(md) {
      margin-left: 2rem;
    }
  }
  &.active {
    opacity: 1;
  }
}

.swiper-slide {
  padding: 0 3rem;
  @include media-breakpoint-up(md) {
    padding: 0;
  }
}

.swiper-nav {
  position: absolute;
  transform: translate(0%, -50%);
  top: 50%;
  font-size: 2rem;
  z-index: 1;
  width: 44px;
  height: 44px;
  background-color: $light-gray;
  border-radius: $border-radius;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: darken($light-gray, 5%);
  }
  &--next {
    right: 0;
  }
  &--prev {
    left: 0;
  }
}
</style>

<style lang="scss">
.studio-testimonial-preview .testimonial *:last-child {
  margin-bottom: 0;
}
</style>
